import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/**
 * Floating "back to top" button. Appears on the bottom-left of the screen
 * after the user has scrolled more than 300px down. Clicking smoothly
 * scrolls back to the top. Visible primarily on mobile (md:hidden so it
 * doesn't clutter desktop), positioned to avoid the cookie banner / chat
 * widgets that typically sit bottom-right.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible((window.scrollY || window.pageYOffset || 0) > 300);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Zpět nahoru"
      data-testid="back-to-top-btn"
      className={`md:hidden fixed left-4 bottom-4 z-40 w-12 h-12 rounded-full bg-zinc-900 text-white shadow-lg shadow-zinc-900/20 flex items-center justify-center transition-all duration-300 ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <ChevronUp className="w-6 h-6"/>
    </button>
  );
}
